import React from "react";
import moment from "moment";
import "moment/locale/en-gb";
import ReactDOM from "react-dom";
import Highcharts from "highcharts";
import { Provider } from "react-redux";
import MomentUtils from "@date-io/moment";
import { extendMoment } from "moment-range";
import HTML5Backend from "react-dnd-html5-backend";
import { DragDropContextProvider } from "react-dnd";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { ConnectedRouter } from "connected-react-router/immutable";

import store from "infrastructure/store";
import history from "infrastructure/history";
import { initializeHighcharts } from "utils/highcharts.util";
import { DEFAULT_MOMENT_LOCALE } from "app/app.constants";
import ApplicationRoot from "app/components/ApplicationRoot";

extendMoment(moment);

initializeHighcharts(Highcharts);

ReactDOM.render(
  <Provider store={store}>
    <MuiPickersUtilsProvider utils={MomentUtils} locale={DEFAULT_MOMENT_LOCALE}>
      <DragDropContextProvider backend={HTML5Backend}>
        <ConnectedRouter history={history}>
          <ApplicationRoot />
        </ConnectedRouter>
      </DragDropContextProvider>
    </MuiPickersUtilsProvider>
  </Provider>,
  document.getElementById("root"),
);
